export default __webpack_public_path__ + "static/media/mn_tea_head_5.2945db9a.png";